import { alpha } from '@mui/material';
const useImageUploadStyles = (centerVariant) => {
    return {
        deleteImage: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '144px',
            height: '144px',
            position: 'relative',
            borderRadius: '50%',
            zIndex: 60,
            border: '1px dashed #919EAB33'
        },
        outerCircularContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '144px',
            height: '144px',
            position: 'relative',
            borderRadius: '50%',
            zIndex: 60,
            border: '1px dashed #919EAB33',
            '& label[role="button"]:focus-within': {
                outline: 'none !important'
            },
            '& label[role="button"] input[type="file"]:focus': {
                outline: 'none !important'
            }
        },
        innerCircularContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '128px',
            flexDirection: 'column',
            height: '128px',
            position: 'absolute',
            borderRadius: '50%',
            zIndex: 50,
            border: '1px dashed #919EAB33',
            top: 6,
            left: 6,
            gap: 1,
            backgroundColor: (theme) => centerVariant ? 'rgba(0, 0, 0, 0.5)' : alpha(theme.palette.grey[500], 0.08),
            cursor: 'pointer'
        },
        deleteIconButton: {
            position: 'absolute',
            bottom: 12,
            right: 16,
            zIndex: 70,
            padding: '4px',
            backgroundColor: (theme) => theme.palette.error.lighter
        },
        editIconButton: {
            position: 'absolute',
            bottom: 12,
            right: 16,
            zIndex: 70,
            padding: '4px',
            backgroundColor: (theme) => theme.palette.background.paper
        }
    };
};
export default useImageUploadStyles;
